import { combineEpics } from 'redux-observable'

import AffMailboxesDetailEpics from './AffMailboxesDetail/epics'
import AtoIncidentEpics from './AtoIncident/epics'
import ListEpics from './List/epics'
import MailboxInfoModalEpics from './MailboxInfoModal/epics'
import RemediatedIncidentsEpics from './RemediatedIncidents/epics'
import ReportEpics from './Report/epics'
import ReportCommentsEpics from './ReportComments/epics'
import ReportCommunicationModal from './ReportCommunicationModal/epics'
import ReportedIncidentsEpics from './ReportedIncidents/epics'
import ScanBack from './ScanBack/epics'
import ScannerDetailEpics from './ScannerDetail/epics'
import ServerScanEpics from './ServerScan/epics'
import TagsClassificationEpics from './TagsClassification/epics'

export default combineEpics(
  ListEpics,
  ReportEpics,
  AtoIncidentEpics,
  RemediatedIncidentsEpics,
  ReportedIncidentsEpics,
  ServerScanEpics,
  ScannerDetailEpics,
  TagsClassificationEpics,
  AffMailboxesDetailEpics,
  ReportCommentsEpics,
  ReportCommunicationModal,
  ScanBack,
  MailboxInfoModalEpics
)
